import { PrivateInterceptor } from "../../interceptors/PrivateInterceptor";
import { PrivateInterceptorIPS } from "../../interceptors/PrivateInterceptorIPS";
import { PublicInterceptor } from "../../interceptors/PublicInterceptor";


export const getCompany = async () => {
    const result = await PrivateInterceptor(`Base/proveedores/Company`, 'GET');
    return result;
}

export const getProveedor = async(IdCustomer) =>{
    const result = await PrivateInterceptor(`Base/proveedores/Proveedor/${IdCustomer}`, 'GET' )
    return result;
}

export const getProveedorId = async(IdCustomer) =>{
    const result = await PrivateInterceptor(`Base/proveedores/ProveedorById/${IdCustomer}`, 'GET' )
    return result;
}

export const getCAIsProveedor = async (IdCustomer) =>{
    const result = await PrivateInterceptor(`Base/proveedores/proveedorCAI/${IdCustomer}`, 'GET');
    return result;
}

export const postProveedorCAI = async(datos) =>{
    const result =await PrivateInterceptor(`Base/proveedores/IUproveedorCAI`, 'POST', datos)
    return result;
}

export const getProveedoresCAI = async() =>{
    const result = await PrivateInterceptor(`Base/proveedores/proveedoresCAI`, 'GET');
    return result;
}

export const getGroupProveedoresCAI = async() =>{
    const result = await PrivateInterceptor(`Base/proveedores/proveedoresCAIGroup`, 'GET');
    return result;
}

export const getArchivoProveedor = async (file, IdCustomer, token = localStorage.getItem('TokenPPFFIN')) => {
    const result = await PrivateInterceptorIPS(`Proveedores/${file}/${IdCustomer}`, 'GET', undefined, token);
    return result;
}


export const getCAIProveedor = async (IdProveedorCAI) =>{
    const result = await PrivateInterceptor(`Base/proveedores/informacionCAI/${IdProveedorCAI}`, 'GET');
    return result;
}

export const getSeleccionCAIsProveedor = async (IdProveedor) =>{
    const result = await PrivateInterceptor(`Base/proveedores/SeleccionProveedorCAI/${IdProveedor}`, 'GET');
    return result;
}

// OBTENER ENLACE DE INSCRIPCION DE UN PROVEEDOR
export const getEnlaceInscripcion = async (IdCustomer, IdUser, Finanzas) => {
    const result = await PrivateInterceptor(`Base/proveedores/LinkInscripcion`, 'POST', {IdCustomer, IdUser, Finanzas});
    return result;
}

// ACTUALIZAR ESTADO DE EDICION DEL ENLACE DE INSCRIPCION DEL PROVEEDOR 
export const updateEnlaceInscripcion = async (body) => {
    const result = await PrivateInterceptor(`Base/proveedores/actualizarEstadoEdicion`, 'PUT', body);
    return result;
}

// OBTENER ARCHIVO FORMATO INSCRIPCION
export const getArchivoFormatoInscripcion = async (IdCustomer, token = localStorage.getItem('ppfToken')) => {
    const result = await PublicInterceptor(`Base/proveedores/FormatoInscripcion/${IdCustomer}`, 'GET', undefined, token);
    return result;
}

// OBTIENER INFORMACION DE UN PROVEEDOR
export const getProveedorInfo = async(IdCustomer, token) => {
    const result = await PublicInterceptor(`Base/proveedores/getProveedor`, 'POST',IdCustomer, token )
    return result;
}

export const getProveedorPorID = async(IdCustomer, Token) => {
    const result = await PublicInterceptor(`Base/proveedores/getProveedorPorID`, 'POST', {IdCustomer}, Token)
    return result;
}

export const CambiarEstado = async(IdStatus, IdCustomer) => {
    const result = await PrivateInterceptor(`Base/proveedores/CambiarEstado`, 'POST', {IdStatus, IdCustomer})
    return result;
}

// export const CambiarEstadoRevision = async(IdStatus, IdCustomer, IdUser) => {
//     const result = await PrivateInterceptor(`Base/proveedores/CambiarEstadoRevision`, 'POST', {IdStatus, IdCustomer, IdUser})
//     return result;
// }

export const CambiarEstadoRevision = async(Data) => {
    const result = await PrivateInterceptor(`Base/proveedores/CambiarEstadoRevision`, 'POST', Data)
    return result;
}
export const RevisarFormularioCompras = async(Data) => {
    const result = await PrivateInterceptor(`Base/proveedores/RevisarFormularioCompras`, 'POST', Data)
    return result;
}
export const CambiarEstadoRevisionIT = async(Data) => {
    const result = await PrivateInterceptor(`Base/proveedores/CambiarEstadoRevisionIT`, 'POST', Data)
    return result;
}


export const CambiarStatus = async(IdStatus, IdRegistro) => {
    const result = await PrivateInterceptor(`Base/proveedores/CambiarStatusRegistro`, 'POST', {IdStatus, IdRegistro})
    return result;
}

export const getCompanyCompras = async () => {
    const result = await PrivateInterceptor(`Base/proveedores/CompanyCompras`, 'GET');
    return result;
}

export const getCompanyVarios = async () => {
    const result = await PrivateInterceptor(`Base/proveedores/CompanyVarios`, 'GET');
    return result;
}

export const postCambiarProveedorCAI = async(Data) =>{
    const result =await PrivateInterceptor(`Base/proveedores/CambiarProveedorCAI`, 'POST', {Data})
    return result;
}

export const postCategoriaProveedor = async(Data) =>{
    const result = await PrivateInterceptor(`Base/proveedores/CambiarCategoriaProveedor`, 'POST',{Data})
    return result
}

//Tipos CAI
export const getTiposCAI = async () => {
    const result = await PrivateInterceptor(`Base/proveedores/TiposCAIActivos`, 'GET');
    return result;
};

export const postSolicitudEdicionProv = async (Datos) =>{
    const result = await PrivateInterceptor(`Base/proveedores/EnviarSolicitudesEdicion`, 'POST',{Datos})
    return result;
}

export const getAllSolicitudesEdicion = async (FechaInicio, FechaFinal) => {
    const result = await PrivateInterceptor(`Base/Proveedores/AllSolicitudesEdicion`, 'POST', { FechaInicio, FechaFinal });
    return result;
}

export const getInscripcionProveedorEditable = async (IdProveedor, IdEstado, token) => {
    const result = await PublicInterceptor(`Base/proveedores/InscripcionProveedorEditable/${IdProveedor}/${IdEstado}`, 'GET', token);
    return result;
};

export const getSolicitudesEdicionId = async (IdSolicitudEdicion) =>{
    const result = await PrivateInterceptor(`Base/Proveedores/SolicitudesEdicionId`, 'POST', {IdSolicitudEdicion})
    return result;
}

export const UpdSolicitudesEdicion = async (Datos)=>{
    const result = await PrivateInterceptor(`Base/Proveedores/UpdateSolicitudesEdicion`, 'POST', {Datos})
    return result;
}

export const FinalizarSolicitudEdicion = async (Datos, Token) => {
  const result = await PublicInterceptor(`Base/Proveedores/FinalizarSolicitudEdicion`, 'POST', { Datos }, Token);
  return result;
}

